import { Action } from './Action'
import { Content } from './Content'
import { RemoteUsers } from './RemoteUsers'
import { Root } from './Root'
import { Title } from './Title'

export const ViewHeader = {
  Root,
  Title,
  Content,
  Action,
  RemoteUsers
}
